import { render, staticRenderFns } from "./sectionCom.vue?vue&type=template&id=2e7426df&scoped=true"
import script from "./sectionCom.vue?vue&type=script&lang=js"
export * from "./sectionCom.vue?vue&type=script&lang=js"
import style0 from "./sectionCom.vue?vue&type=style&index=0&id=2e7426df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7426df",
  null
  
)

export default component.exports